import { LinkDataFieldValue } from "./LinkDataFieldValue";

export class ImageDataFieldValue extends LinkDataFieldValue {
	public static readonly $type: string = "ImageDataFieldValue";
	public readonly $type: string = ImageDataFieldValue.$type;

	public filename: string = "";
	public binary: Blob = new Blob();
}
